import { forwardRef } from 'react';

import EntityDefaultChildren from '@/components/FilterManager/EntityFilter/components/EntityDefaultChildren';
import FilterPillLoader from '@/components/FilterManager/EntityFilter/components/FilterPillLoader';

import { EntityFilterPillProps } from '../types';

const EntityFilterPill = forwardRef<any, EntityFilterPillProps>((props, ref) => {
  const { useFilterValuesResult, ...pillProps } = props;
  const { fetching, resolvedValue } = useFilterValuesResult;

  // saves the shimmer effect when there is already a value in the pill
  // basically, only show the effect for the first time
  return !resolvedValue?.length && fetching ? (
    <FilterPillLoader className="mb-8 me-8" />
  ) : (
    <EntityDefaultChildren ref={ref} selectedValues={resolvedValue} {...pillProps} />
  );
});

EntityFilterPill.displayName = 'EntityFilterPill';

export default EntityFilterPill;
